export default (sitemap: SitemapBuilder) =>
{
    sitemap.push([
        {
            name: '[[[Page Builder]]] (β)',
            visible: false,
            route: 'pagebuilder-home'
        }
    ]);
};
